<template>
  <message-form>
    <ButtonUpdate class="mt_m"/>
    <ButtonDelete class="mt_s"/>
  </message-form>
</template>

<script>
import MessageForm from '@/components/Message/Form'
import ButtonUpdate from '@/components/Message/ButtonUpdate'
import ButtonDelete from '@/components/Message/ButtonDelete'

export default {
  components: {
    MessageForm,
    ButtonUpdate,
    ButtonDelete
  },
  created: async function () {
    await this.$store.dispatch(
      'message/getMessage',
      this.$route.params.id
    )
    this.$store.dispatch('message/initForm')
  }
}
</script>
